import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { LocalizePipe } from "@webapp/localization/pipes/localize.pipe";
import { ReflectionMoodType, reflectionMoodTypes } from "@webapp/reflections/models/reflections.models";

@UntilDestroy()
@Component({
  selector: "reflection-mood",
  templateUrl: "./reflection-mood.component.html",
  styleUrls: ["./reflection-mood.component.less"],
  providers: [LocalizePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionMoodComponent {
  @Input() public isEditModeEnabled: boolean;
  @Input() public reflectionMood: ReflectionMoodType;
  @Input() public cadenceStartDate: string;
  @Output() public readonly moodChange = new EventEmitter<ReflectionMoodType>();

  public reflectionMoodTypes = reflectionMoodTypes;
  public isCheckInsUxImprovementsEnabled: boolean;

  constructor(featureToggleFacade: FeatureTogglesFacade, private localizePipe: LocalizePipe) {
    featureToggleFacade
      .isFeatureAvailable$(FeatureFlag.CheckInsUxImprovements)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (enabled) => {
          this.isCheckInsUxImprovementsEnabled = enabled;
        },
      });
  }

  public updateMood(mood: ReflectionMoodType): void {
    this.moodChange.emit(mood);
  }

  public buildAriaLabelByMood(mood: ReflectionMoodType): string {
    if (["bad", "good", "neutral"].includes(mood)) {
      return this.localizePipe.transform(`${mood}_mood`);
    }
    return this.localizePipe.transform("manage_reflections_mood_title");
  }
}
